import * as React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import { useTitleStore } from 'src/stores/useTitleStore';
import { systemsMessages } from 'src/features/systems/utils/messages';
import { administrationMessages } from 'src/features/administration/utils/messages';
import SystemSettings from 'src/features/systems/routes/SystemSettings';
import DisplaySettings from 'src/features/systems/components/displaySettings/DisplaySettings';
import { displaySettingsMessages } from 'src/features/systems/utils/displaySettingsMessages';

const SystemSettingsLayout = () => {
    const { formatMessage } = useIntl();

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(administrationMessages.settings));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <Tabs defaultValue="system-settings">
            <TabsList>
                <TabsTrigger value="system-settings">
                    <FormattedMessage {...systemsMessages.systemSettings} />
                </TabsTrigger>

                <TabsTrigger value="display-settings">
                    <FormattedMessage {...displaySettingsMessages.displaySettings} />
                </TabsTrigger>
            </TabsList>

            <TabsContent value="system-settings">
                <SystemSettings />
            </TabsContent>
            <TabsContent value="display-settings">
                <DisplaySettings />
            </TabsContent>
        </Tabs>
    );
};

export default SystemSettingsLayout;
